// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--dApDq","content":"a10a3f92e9--content--uT4ns","description":"a10a3f92e9--description--Mmfnj"};